import {
  Component,
  Input,
  Output,
  OnInit,
  SimpleChanges,
  ViewChild,
  EventEmitter
} from '@angular/core';
import { AssetData } from 'src/app/models/assetData.model';
import { SelectItem } from 'src/app/models/mapFilter.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MapComponent } from '../../map/map.component';
import { Coordinates } from 'src/app/models/coordinates.model';
import { MapToggleService } from 'src/app/services/map-toggle.service';

@Component({
  selector: 'sales-management',
  templateUrl: './sales-management.component.html',
  styleUrls: ['./sales-management.component.scss'],
})
export class SalesManagementComponent implements OnInit {
  @ViewChild('childRef', { static: false }) childComponent: MapComponent;

  customersOpen: boolean = false;
  buildingsOpen: boolean = false;
  polesOpen: boolean = false;
  transformersOpen: boolean = false;

  @Output() buttonClicked = new EventEmitter<string>();

  @Input() increasement: number = 0;
  @Input() polesData: AssetData = new AssetData();
  @Input() customersData: AssetData = new AssetData();
  @Input() buildingsData: AssetData = new AssetData();
  @Input() transformersData: AssetData = new AssetData();
  @Input() mapData: SelectItem[] = [];
  @Input() areaIds: number[] = [];
  @Input() dtsIds: number[] = [];
  @Input() utilityId: number;
  @Input() reloadMapTrigger: boolean = true;
  isMapToggled: boolean = false;

  defaultCoordinates: Coordinates;
  mapConfiguration: any = null;

  constructor(private dashboardService: DashboardService, private mapToggleService: MapToggleService) {
    this.mapToggleService.isMapToggled$.subscribe((state) => {
 
      this.isMapToggled = !state;
    });
  }

  ngOnInit(): void {
    const mapConfig = localStorage.getItem('mapConfiguration');
    this.mapConfiguration = mapConfig ? JSON.parse(mapConfig) : null;

    if (this.mapConfiguration) {
      this.defaultCoordinates = new Coordinates(
        this.mapConfiguration.latitude,
        this.mapConfiguration.longitude
      );
      return;
    }

    this.getDefaultCoordinates(this.utilityId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.mapConfiguration) return;

    if (changes['utilityId'] &&
      changes['utilityId'].previousValue != changes['utilityId'].currentValue)
      this.getDefaultCoordinates(
        changes['utilityId'].currentValue.length == 1
          ? this.utilityId
          : undefined
      );
    if (changes['dtsIds']) {
      this.getDefaultCoordinates();
    }
  }

  switchButtonClicked (buttonClicked: string): void{
    this.buttonClicked.emit(buttonClicked);
  }

  onMapExpandedChanged(isMapExpanded: boolean) {
    this.isMapToggled = isMapExpanded;
  }

  getDefaultCoordinates(utilityId?: number) {
    if (this.utilityId && !this.mapConfiguration) {
      this.defaultCoordinates = new Coordinates(
        5.6026283219970585,
        -0.18522295756972676
      );
      return this.defaultCoordinates;
    }
    var obj = {
      areasIds: [],
      utilityId: utilityId ?? 0,
      dtsIds: this.dtsIds,
    };

    this.dashboardService.getDefaultCoordinates(obj).subscribe({
      next: (data) => {
        this.defaultCoordinates = new Coordinates(
          data.body?.latitude ?? 0,
          data.body?.longitude ?? 0
        );
      },
      error: (error) => console.log(error.statusText),
    });

    return this.defaultCoordinates;
  }
}
